import * as S from './Input.styles';
import { InputProps } from './Input.types';

const Input = (props: InputProps): JSX.Element => <S.Input {...props} sx={S.InputStyles} size="small" />;

export default Input;
